import React from "react";
import DoneButton from "./DoneButton";
import autoBind from "react-autobind";
import { branch } from "baobab-react/higher-order";
import request from "superagent";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import withPlayerItemHoc from "./PlayerItemHoc";

import partlyCloudyDay from "../../assets/weather-icons/partly-cloudy-day.png";
import partlyCloudyNight from "../../assets/weather-icons/partly-cloudy-night.png";
import clearDay from "../../assets/weather-icons/clear-day.png";
import clearNight from "../../assets/weather-icons/clear-night.png";
import rain from "../../assets/weather-icons/rain.png";
import snow from "../../assets/weather-icons/snow.png";
import sleet from "../../assets/weather-icons/sleet.png";
import wind from "../../assets/weather-icons/wind.png";
import fog from "../../assets/weather-icons/fog.png";
import cloudy from "../../assets/weather-icons/cloudy.png";
import hail from "../../assets/weather-icons/hail.png";
import thunderstorm from "../../assets/weather-icons/thunderstorm.png";
import tornoado from "../../assets/weather-icons/tornado.png";
import meteorShower from "../../assets/weather-icons/meteor-shower.png";
import defaultIcon from "../../assets/weather-icons/default.png";

import * as playerActions from "../../actions/playerActions";
import * as alertActions from "../../actions/alertActions";

import env from "../../constants/env";

const weatherIcons = {
	"partly-cloudy-day":partlyCloudyDay, 
	"partly-cloudy-night":partlyCloudyNight, 
	"clear-day":clearDay, 
	"clear-night":clearNight, 
	"rain":rain, 
	"snow":snow, 
	"sleet":sleet, 
	"wind":wind, 
	"fog":fog, 
	"cloudy":cloudy, 
	"hail":hail, 
	"thunderstorms":thunderstorm, 
	"tornado":tornoado, 
	"meteor-shower":meteorShower, 
	"default":defaultIcon 
};

class PlayerWeather extends React.PureComponent {

	constructor(props) {
		super(props);
		this.readOnly = false;
		autoBind(this);
		this.state = {
			value: this.props.item.value
		};
	}

	render() {
		if (this.props.readOnly) {
			return this.renderReadOnly();
		} else {
			return this.renderEditable();
		}
	}

	componentDidMount() {
		this.getPositionAndFetchWeather();
	}

	async getPositionAndFetchWeather() {		
		let self = this;
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition((position) => {
				self.fetchWeather(position.coords.latitude, position.coords.longitude);
			}, (error) => {
				this.setState({
					geoLocationError: error.message
				});
			});
		} else {
			this.state.set({
				geoLocationNotSupported: true
			});
		}
	}


	onSubmit() {
		if (this.props.onSubmit) { this.props.onSubmit(this.state.value); }
	}

	fetchWeather(lat, lng) {
		if (this.props.geolocationTracking) {
			if (lat === null || lng === null) {
				this.setState({ value: null });
				this.props.dispatch(playerActions.handleChangeProperty, this.props.listIndex, this.props.sectionIndex, this.props.itemIndex, "value", null);
				return;
			}

			let responseJsonDarkSky;			
			
			request.get(env.weather.url + "/" + lat + "," + lng)
				.set("Content-Type", "application/json")
				.then((response) => {					
					responseJsonDarkSky = response.body;
					return request.get("https://services.swpc.noaa.gov/products/noaa-planetary-k-index.json");
				})
				.then((response) => {
					try {
						let newResponseJson = Object.assign(responseJsonDarkSky, { "kpIndex": response.body });
						//console.log("Fetch Weather: " + JSON.stringify(newResponseJson));
						this.setState({ value: newResponseJson });
						this.props.dispatch(playerActions.handleChangeProperty, this.props.listIndex, this.props.sectionIndex, this.props.itemIndex, "value", newResponseJson);
					} catch (e) {
						alertActions.showAlert("Error", "Error getting weather details: " + e.message);
					}

				})
				.catch((err) => {
					alertActions.showError("Error on request", err.message);
				});
		} else {
			alertActions.showError("Error","Error in geolocation tracking");
			//this.setState( {value: null} );      
			//this.props.dispatch(actions.handleChangeProperty,this.props.listIndex,this.props.sectionIndex,this.props.itemIndex,"value",null);
		}
	}


	getWeatherValue(value) {
		let weatherValue = {};
		
		if (!value || value === null) {
			weatherValue.hasWeather = false;
			weatherValue.message = "No weather location.";
		} else {

			let kpIndexArray = value.kpIndex;
			let kpIndexLastArray = kpIndexArray[kpIndexArray.length - 1];
			let kpIndex = kpIndexLastArray[1];

			weatherValue.kpIndex = kpIndex;

			if (!value.hasOwnProperty("currently")) {
				weatherValue.hasWeather = false;
				weatherValue.message = "No weather data.";
			} else {
				weatherValue.hasWeather = true;
	
				weatherValue.icon = value.currently.icon;
	
				if (value.hasOwnProperty("currently") && value.currently.hasOwnProperty("summary")) {
					weatherValue.currentlySummary = value.currently.summary;
				}
	
				if (value.hasOwnProperty("minutely") && value.minutely.hasOwnProperty("summary")) {
					weatherValue.minutelySummary = value.minutely.summary;
				}
	
				if (value.hasOwnProperty("hourly") && value.hourly.hasOwnProperty("summary")) {
					weatherValue.hourlySummary = value.hourly.summary;
				}
	
				let summary;
	
				if (weatherValue.minutelySummary !== "" && weatherValue.hourlySummary !== "") {
					summary = weatherValue.minutelySummary + " " + weatherValue.hourlySummary;
				} else if (weatherValue.minutelySummary !== "") {
					summary = weatherValue.minutelySummary;
				} else if (weatherValue.hourlySummary !== "") {
					summary = weatherValue.hourlySummary;
				}
	
				weatherValue.summary = summary;
				
				weatherValue.temperature = (!value.currently.hasOwnProperty("temperature"))?"None":(Math.round(10 * value.currently.temperature)/10) + " °F";
				weatherValue.dewPoint = (!value.currently.hasOwnProperty("dewPoint"))?"None":(Math.round(10 * value.currently.dewPoint)/10) + " °F";
				weatherValue.humidity = (!value.currently.hasOwnProperty("humidity"))?"None":Math.round(value.currently.humidity * 1000)/10 + "%";
				weatherValue.precipitationType = (!value.currently.hasOwnProperty("precipType"))?"None":value.currently.precipType;
				weatherValue.precipitationProbability = (!value.currently.hasOwnProperty("precipProbability"))?"None":Math.round(value.currently.precipProbability * 1000)/10;
				weatherValue.cloudCover = (!value.currently.hasOwnProperty("cloudCover"))?"None":Math.round(value.currently.cloudCover * 1000)/10 + "%";
				weatherValue.windDirection = (!value.currently.hasOwnProperty("windBearing"))?"None":value.currently.windBearing;
				weatherValue.windSpeed = (!value.currently.hasOwnProperty("windSpeed"))?"None":value.currently.windSpeed;
				weatherValue.windGust = (!value.currently.hasOwnProperty("windGust"))?"None":value.currently.windGust;
				weatherValue.visibility = (!value.currently.hasOwnProperty("visibility"))?"None":value.currently.visibility;
			}
		}
		
		return weatherValue;
	}

	renderWeather(value) {
		value = this.getWeatherValue(value);

		if (value.hasWeather) {
			return (
				<div>
					<p>
						<img alt="" src={weatherIcons[value.icon]}/>
					</p>
					<p>
						<b>Current Forecast</b><br/>
						{value.currentlySummary}
					</p>
					<p>
						<b>Summary Forecast</b><br/>
						{value.summary}
					</p>
					<table border="0" style={{borderCollapse: "collapse"}} cellspacing="3" cellpadding="3">
						<tr>
							<td><b>Temperature</b></td>
							<td>{value.temperature}</td>
						</tr>
						<tr>
							<td><b>Dew Point</b></td>
							<td>{value.dewPoint}</td>
						</tr>
						<tr>
							<td><b>Humidity</b></td>
							<td>{value.humidity}</td>
						</tr>
						<tr>
							<td><b>Precipitation Type</b></td>
							<td>{value.precipitationType}</td>
						</tr>
						<tr>
							<td><b>Precipitation Probability</b></td>
							<td>{value.precipitationProbability}</td>
						</tr>
						<tr>
							<td><b>Cloud Cover</b></td>
							<td>{value.cloudCover}</td>
						</tr>
						<tr>
							<td><b>Wind Direction</b></td>
							<td>{value.windDirection}</td>
						</tr>
						<tr>
							<td><b>Wind Speed</b></td>
							<td>{value.windSpeed}</td>
						</tr>
						<tr>
							<td><b>Wind Gust</b></td>
							<td>{value.windGust}</td>
						</tr>
						<tr>
							<td><b>Visibility</b></td>
							<td>{value.visibility}</td>
						</tr>
						<tr>
							<td><b>KP-Index</b></td>
							<td>{value.kpIndex}</td>
						</tr>
					</table>
				</div>
			);
		} else {
			return (
				<p>
					{value.message}
				</p>
			);
		}
	}

	renderReadOnly() {

		const { item, getLabelsReadOnly, getImage, getVideo, getPdf } = this.props;

		// let imgUrl;

		// if (item.hasOwnProperty("sketchPadImage") && item.sketchPadImage !== null && item.sketchPadImage !== "") {
		// 	imgUrl = "<p><b>Sketch</b><br/><a href='" + item.sketchPadImage + "' target='blank'><img style='width: 30%; border: 1px solid #eeeeee' src='" + item.sketchPadImage + "' /></a></p>";
		// } else {
		// 	imgUrl = "<p><b>Sketch</b><br/>No sketch added.</p>";
		// }
		const component =
			<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
				<div style={{ width: "100%" }}>
					{getLabelsReadOnly()}
					{getImage()}
					{getVideo()}
					{getPdf()}
					{this.renderWeather(item.value)}
				</div>
			</div>;

		return component;
	}

	renderEditable() {
		const { getLabels, getImage, getVideo, getPdf, disabled } = this.props;

		const component =
			<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
				<div style={{ width: "100%" }}>
					{getLabels()}
					{getImage()}
					{getVideo()}
					{getPdf()}								
					{this.renderWeather(this.state.value)}
					{!disabled && <DoneButton onSubmit={this.onSubmit} />}
				</div>
			</div>;

		return component;
	}
}

export default branch({
	weatherApiKey: ["weather", "apiKeyDarkSky"],
	geolocationTracking: ["appCapabilities", "geolocationTracking"],
}, withPlayerItemHoc(PlayerWeather));




